import { Popup } from '@calendly/ui/components/popup'
import { useDispatch, useSelector } from 'react-redux'

import { fetchCurrentSubscription } from 'features/billing/actions/fetch_current_subscription'
import { resetCreateSubscription } from 'features/billing/create_subscription_slice'

import { Loading } from './loading'
import { NonRenewingModal } from './non_renewing_modal'
import { isLoadingSelector, isSuccessSelector } from './selectors'
import { reset as resetPromptToRemoveNonRenewingDowngrade } from './slice'
import { Success } from './success'

const Contents = ({ isLoading, isSuccess, onClose }) => {
  if (isLoading) {
    return <Loading />
  }

  if (isSuccess) {
    return <Success onClose={onClose} />
  }

  return <NonRenewingModal onClose={onClose} />
}

export const ModalWrapper = () => {
  const isLoading = useSelector(isLoadingSelector)
  const isSuccess = useSelector(isSuccessSelector)
  const dispatch = useDispatch()

  const onClose = () => {
    dispatch(resetPromptToRemoveNonRenewingDowngrade())
    dispatch(resetCreateSubscription())
    dispatch(fetchCurrentSubscription())
  }


  return (
    <Popup onClose={onClose}>
      <Contents isSuccess={isSuccess} isLoading={isLoading} onClose={onClose} />
    </Popup>
  )
}
